// extracted by mini-css-extract-plugin
export default {"form":"BookSlots_form__Fnw-9"};